import { ISimpleBalance } from "../config/interface";
import { store } from "../../../Redux";
import { callCheckGSMBalance } from "../../../Redux/slices/balanceSlice";
import { createCheckGSMBalancePayload } from "../config/balancePayloads";
import { getPhoneNumberFromLs } from "../../../utils/commonUtils";
import { sortBy } from "../../../helpers/commonHelpers";
import { minBalanceEventHelper } from "../../../helpers/eventHelper";
import dayjs from "dayjs";

// sort input bundle balance by expiry date time
export function sortISimpleBalanceDetailsByDateTime(
  details: ISimpleBalance["details"],
  objDTFormat?: string
) {
  if (objDTFormat) {
    return sortBy(details, (kv) =>
      dayjs(kv?.value?.expiry, objDTFormat)
    );
  }
  return sortBy(details, (kv) => dayjs(kv?.value?.expiry));
}

export function fetchBalance(hideLoader = false, payload = {}) {
  let msisdn = getPhoneNumberFromLs() || "";
  store.dispatch(callCheckGSMBalance(createCheckGSMBalancePayload({ msisdn, ...payload }, hideLoader)));
  minBalanceEventHelper();
}